import React, { ReactNode } from 'react';

import { Box } from 'components/Box';
import { Hide } from 'components/Hide';
import { BodyMicro } from 'components/Text';
import { colors } from 'theme';

type Props = {
  children?: ReactNode;
};

export function PageHeaderMobileSectionTitle({ children, ...props }: Props) {
  return (
    <Hide lg xl>
      <Box
        borderTop={`1px solid ${colors.aluminum}`}
        pt={40}
        mt={40}
        // TODO: Fix this the next time the file is edited.
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...props}
      >
        {children && <BodyMicro color={colors.silver}>{children}</BodyMicro>}
      </Box>
    </Hide>
  );
}
